// Start collection reviews after HTML parsing, without waiting for window.load.
// Keep Shopify's app loader intact as a fallback. Loox guards its own initialization
// with __looxLoaded / widgetRunOnce when that loader subsequently runs.
(() => {
  const widget = document.querySelector('#looxReviews[data-loox-collection="true"]');
  if (!widget || window.Shopify?.designMode) return;

  const status = document.createElement('div');
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.style.cssText = 'padding:24px 16px;text-align:center;width:100%;';
  status.textContent = 'Loading customer reviews…';
  widget.before(status);

  let finished = false;
  let timeout;
  const observer = new ResizeObserver(() => {
    const frame = widget.querySelector('iframe');
    if (frame && frame.getBoundingClientRect().height > 0) {
      finished = true;
      clearTimeout(timeout);
      status.remove();
      observer.disconnect();
    }
  });
  observer.observe(widget);

  timeout = setTimeout(() => {
    if (finished) return;
    status.textContent = 'Customer reviews are taking longer to load. ';
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'button button-unstyled';
    retry.textContent = 'Try again';
    retry.style.textDecoration = 'underline';
    retry.addEventListener('click', () => window.location.reload());
    status.append(retry);
  }, 20000);

  const isLooxScript = (value) => {
    try {
      const url = new URL(value, location.href);
      return url.protocol === 'https:' && url.hostname === 'loox.io' &&
        /^\/widget\/[^/]+\/loox(?:\.[\w-]+)?\.js$/.test(url.pathname);
    } catch {
      return false;
    }
  };

  if (window.__looxLoaded || [...document.scripts].some(script => isLooxScript(script.src))) return;

  // Read the app's current URL, including its shop and version, without evaluating
  // or rewriting content_for_header. Unknown future formats use Shopify's fallback.
  let source;
  for (const script of document.scripts) {
    if (script.src || !script.textContent.includes('loox.io') || !/var\s+urls\s*=/.test(script.textContent)) continue;
    const match = script.textContent.match(/var\s+urls\s*=\s*(\[[^\]]*\])/);
    if (!match) continue;
    try {
      source = JSON.parse(match[1]).find(isLooxScript);
    } catch { /* Keep the original app loader as the fallback. */ }
    if (source) break;
  }
  if (!source) return;

  const script = document.createElement('script');
  script.src = source;
  script.async = true;
  script.dataset.collectionReviewsEarly = 'true';
  document.head.append(script);
})();
